import { useQuery } from '@tanstack/react-query';

import { GetSubscriptionItemsResponse } from '@/api/subscriptions/types';
import { RequestOptions, axios } from '@/common/axios';
import { ExtractFnReturnType, QueryConfig } from '@/common/react-query';

export const getSubscriptionItems = async (options?: RequestOptions): Promise<GetSubscriptionItemsResponse> => {
    return axios.get<GetSubscriptionItemsResponse, GetSubscriptionItemsResponse>(
        '/api/v2/subscriptions/available-items',
        options
    );
};

type QueryFnType = typeof getSubscriptionItems;

type UseSubscriptionsItemsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useSubscriptionsItems = ({ config }: UseSubscriptionsItemsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['stripe-subscription-items'],
        queryFn: ({ signal }) => getSubscriptionItems({ signal }),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
